import React, { useMemo } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LANDRATES } from '../../../../appConstants';
import { IOptionType } from '../../../../@types/model/optionType';

interface ILandrateDropdownProps {
    value : number | null;
    onChange : (value : number | null) => void;
}

const LandrateDropdown = (props : ILandrateDropdownProps) : React.ReactElement => {

    const options = useMemo<Array<IOptionType>>(() => {
        return Object.keys(LANDRATES).map(x => ({
            label: LANDRATES[Number(x)],
            value: Number(x),
        }));
    }, []);

    const onChange = (event : React.ChangeEvent<unknown>, value : IOptionType | null) => {
        const parsedValue = value != null
            ? Number(value.value)
            : null;

        props.onChange(parsedValue);
    };

    const selectedOptionType = useMemo<IOptionType | null>(() => {
        return options.find(x => x.value === props.value) ?? null;
    }, [props.value, options]);

    return (
        <FormControl fullWidth={true} error={props.value == null} required={true}>
            <Autocomplete
                options={options}
                value={selectedOptionType}
                getOptionSelected={(option, val) => option.label === val.label}
                getOptionLabel={option => option.label}
                onChange={onChange}
                disableClearable={false}
                openOnFocus
                renderInput={params => <TextField error={props.value == null} {...params} fullWidth={true} label={'Landrate'} />}
            />
            {
                props.value == null &&
                <FormHelperText error>Required</FormHelperText>
            }
            <div className='wfill' style={{
                minHeight: 8,
            }}>
            </div>
        </FormControl>
    );
};

export default LandrateDropdown;